import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUserDetails } from '../redux/user-details/actions';
import { getUserDetailsState } from '../redux/user-details/selectors';
import * as _ from 'lodash';
import { isEqual } from 'lodash';
import { withRouter } from 'react-router-dom';
import './UserDetails.scss';
import { UserInfo } from '../user-info/UserInfo';
import { updateUser } from '../redux/update-user/actions';
import { EditButton } from '../../../../../shared/button/EditButton';
import EditUserModal from '../edit-user/EditUserModal';
import { extendWithModalSupport } from '../../../../../shared/modal-container/ModalContainer';
import { PageActionsRow } from '../../../../../shared/headers/PageActionsRow';
import { BackButton } from '../../../../../shared/button/back-button/BackButton';
import {
    getSelectedBrandId,
    getSelectedJurisdictionCode
} from '../../../../../jurisdiction/redux/selectors';
import {
    defaultFirstPage,
    defaultItemsPerPage
} from '../../../../../services/Paging';
import HistoryOfAlerts from '../../../players/player-details/content/HistoryOfAlerts';
import { fetchAlerts } from '../../../alerts/list/redux/actions';
import { getAlertsState } from '../../../alerts/list/redux/selectors';
import { makeRuleTypeDropdownOptions } from '../../../../../shared/models/rule-type';
import ShowIfPermission from '../../../../../shared/show-if-permission/ShowIfPermission';
import { PermissionEnum } from '../../../../../shared/models/permissions';

class UserDetails extends Component {
    constructor(props) {
        super(props);
        extendWithModalSupport(this);
        this.state = {
            alertPagination: {
                pageSize: defaultItemsPerPage,
                page: defaultFirstPage
            },
            alertSort: {},
            alertFilters: {
                type: null,
                severity: null,
                status: null
            }
        };
    }

    componentDidMount() {
        const { fetchUserDetails } = this.props;
        const { userId } = this.props.match.params;

        _.isFunction(fetchUserDetails) && fetchUserDetails(userId);
        this.fetchUserAlertsFromState();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            !isEqual(prevProps.jurisdictionCode, this.props.jurisdictionCode) ||
            !isEqual(prevProps.brandId, this.props.brandId)
        ) {
            this.fetchUserAlertsFromState();
        }
    }

    fetchUserAlertsFromState = () => {
        const { userId } = this.props.match.params;
        const { jurisdictionCode, brandId, fetchUserAlerts } = this.props;
        const { type, severity, status } = this.state.alertFilters;

        _.isFunction(fetchUserAlerts) &&
            fetchUserAlerts({
                pagination: this.state.alertPagination,
                sort: {
                    sortType: this.state.alertSort.sortingKey,
                    sortOrder: this.state.alertSort.sortDirection
                },
                brandId,
                jurisdictionCode,
                ruleType: type,
                alertLevel: severity,
                dismissType: status,
                dismissedBy: userId
            });
    };

    makeAlertFiltersConfig = () => ({
        typeConfig: {
            label: 'Rule Type',
            options: makeRuleTypeDropdownOptions()
        },
        severityConfig: {},
        statusConfig: {}
    });

    updateAlertsPagination(pagination) {
        this.setState(
            {
                ...this.state,
                alertPagination: pagination
            },
            () => this.fetchUserAlertsFromState()
        );
    }

    updateAlertsSort(alertSort) {
        this.setState(
            {
                ...this.state,
                alertSort
            },
            () => this.fetchUserAlertsFromState()
        );
    }

    handleAlertsApplyFilters = alertFilters => {
        this.setState(
            {
                ...this.state,
                alertPagination: {
                    ...this.state.alertPagination,
                    page: defaultFirstPage
                },
                alertFilters
            },
            () => this.fetchUserAlertsFromState()
        );
    };

    handleAlertsClearFilters = alertFilters =>
        this.setState(
            {
                ...this.state,
                alertFilters
            },
            () => this.fetchUserAlertsFromState()
        );

    handleAlertsRemoveFilter = alertFilters =>
        this.setState(
            {
                ...this.state,
                alertFilters
            },
            () => this.fetchUserAlertsFromState()
        );

    handleUserActiveSwitch = isActive => {
        const { user, updateUser } = this.props;

        _.isFunction(updateUser) &&
            updateUser(user.id, {
                firstName: user.firstName,
                lastName: user.lastName,
                active: isActive
            });
    };

    render = () => {
        const { user, loaded, userAlerts } = this.props;

        return (
            user && (
                <div className="container user-details">
                    <PageActionsRow>
                        <ShowIfPermission
                            permission={PermissionEnum.MANAGE_USERS}
                        >
                            <EditButton
                                onClick={() => this.modalInstance.openModal()}
                            />
                        </ShowIfPermission>
                        <BackButton />
                    </PageActionsRow>

                    <UserInfo
                        user={user}
                        loaded={loaded}
                        toggleUserActive={this.handleUserActiveSwitch}
                    />

                    <HistoryOfAlerts
                        alerts={userAlerts.data}
                        loading={userAlerts.loading}
                        pagination={{
                            ...this.state.alertPagination,
                            hasNextPage: userAlerts.pagination.hasNextPage
                        }}
                        onPaginationUpdated={pagination =>
                            this.updateAlertsPagination(pagination)
                        }
                        onSortUpdated={sort => this.updateAlertsSort(sort)}
                        filters={this.state.alertFilters}
                        filtersConfig={this.makeAlertFiltersConfig()}
                        applyFilters={this.handleAlertsApplyFilters}
                        clearFilters={this.handleAlertsClearFilters}
                        removeFilter={this.handleAlertsRemoveFilter}
                    />

                    <EditUserModal user={user} ref={this.modalRef} />
                </div>
            )
        );
    };
}

const mapStateToProps = state => {
    const userState = getUserDetailsState(state);

    return {
        user: userState.data,
        loaded: userState.loaded,
        jurisdictionCode: getSelectedJurisdictionCode(state),
        brandId: getSelectedBrandId(state),
        userAlerts: getAlertsState(state)
    };
};

const mapDispatchToProps = dispatch => ({
    fetchUserDetails: userId => dispatch(fetchUserDetails(userId)),
    fetchUserAlerts: args => dispatch(fetchAlerts(args)),
    updateUser: (userId, details) => dispatch(updateUser({ userId, details }))
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(UserDetails)
);
